import Vue from 'vue'
import Vuex from 'vuex'
import snToastService from '../services/snToastService.js'

Vue.use(Vuex)
Vue.config.devtools = true

export const store = new Vuex.Store({
  state: () => ({
    _appInitialized: false,
    _toasts: []
  }),
  getters: {
    appInitialized (state) {
      return state._appInitialized
    },
    toasts (state) {
      return state._toasts
    }
  },
  mutations: {
    setAppInitialized (state, newValue) {
      state._appInitialized = newValue
    },
    setToast (state, newToast) {
      return snToastService.setToast(state, newToast)
    },
    setSuccessToast (state, { message = 'Success', description = '', type = 'simple' }) {
      return snToastService.setSuccessToast(state, { message, description, type })
    },
    setErrorToast (state, { message = 'Error', description = '', type = 'sticky' }) {
      return snToastService.setErrorToast(state, { message, description, type })
    },
    setWarningToast (state, { message = 'Warning', description = '', type = 'sticky' }) {
      return snToastService.setWarningToast(state, { message, description, type })
    }
  }
})
